// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as IndustriesRouteImport } from './routes/industries'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InsightsIndexRouteImport } from './routes/insights.index'
import { Route as ArIndexRouteImport } from './routes/ar/index'
import { Route as InsightsSlugRouteImport } from './routes/insights.$slug'
import { Route as ArServicesRouteImport } from './routes/ar/services'
import { Route as ArPrivacyRouteImport } from './routes/ar/privacy'
import { Route as ArIndustriesRouteImport } from './routes/ar/industries'
import { Route as ArContactRouteImport } from './routes/ar/contact'
import { Route as ArAboutRouteImport } from './routes/ar/about'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesSlugRouteImport } from './routes/services.$slug'
import { Route as IndustriesIndexRouteImport } from './routes/industries.index'
import { Route as IndustriesSlugRouteImport } from './routes/industries.$slug'
import { Route as ArInsightsIndexRouteImport } from './routes/ar/insights.index'
import { Route as ArInsightsSlugRouteImport } from './routes/ar/insights.$slug'
import { Route as ArServicesIndexRouteImport } from './routes/ar/services.index'
import { Route as ArServicesSlugRouteImport } from './routes/ar/services.$slug'
import { Route as ArIndustriesIndexRouteImport } from './routes/ar/industries.index'
import { Route as ArIndustriesSlugRouteImport } from './routes/ar/industries.$slug'
import { Route as ServicesOilGasRegistrationOperatorRouteImport } from './routes/services.oil-gas-registration.$operator'
import { Route as ServicesIsoCertificationCityRouteImport } from './routes/services.iso-certification.$city'
import { Route as ArServicesOilGasRegistrationOperatorRouteImport } from './routes/ar/services.oil-gas-registration.$operator'
import { Route as ArServicesIsoCertificationCityRouteImport } from './routes/ar/services.iso-certification.$city'

const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const IndustriesRoute = IndustriesRouteImport.update({
            id: '/industries',path: '/industries',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const InsightsIndexRoute = InsightsIndexRouteImport.update({
            id: '/insights/',path: '/insights/',getParentRoute: () => rootRouteImport
          })
const ArIndexRoute = ArIndexRouteImport.update({
            id: '/ar/',path: '/ar/',getParentRoute: () => rootRouteImport
          })
const InsightsSlugRoute = InsightsSlugRouteImport.update({
            id: '/insights/$slug',path: '/insights/$slug',getParentRoute: () => rootRouteImport
          })
const ArServicesRoute = ArServicesRouteImport.update({
            id: '/ar/services',path: '/ar/services',getParentRoute: () => rootRouteImport
          })
const ArPrivacyRoute = ArPrivacyRouteImport.update({
            id: '/ar/privacy',path: '/ar/privacy',getParentRoute: () => rootRouteImport
          })
const ArIndustriesRoute = ArIndustriesRouteImport.update({
            id: '/ar/industries',path: '/ar/industries',getParentRoute: () => rootRouteImport
          })
const ArContactRoute = ArContactRouteImport.update({
            id: '/ar/contact',path: '/ar/contact',getParentRoute: () => rootRouteImport
          })
const ArAboutRoute = ArAboutRouteImport.update({
            id: '/ar/about',path: '/ar/about',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesRoute
          })
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ServicesRoute
          })
const IndustriesIndexRoute = IndustriesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => IndustriesRoute
          })
const IndustriesSlugRoute = IndustriesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => IndustriesRoute
          })
const ArInsightsIndexRoute = ArInsightsIndexRouteImport.update({
            id: '/ar/insights/',path: '/ar/insights/',getParentRoute: () => rootRouteImport
          })
const ArInsightsSlugRoute = ArInsightsSlugRouteImport.update({
            id: '/ar/insights/$slug',path: '/ar/insights/$slug',getParentRoute: () => rootRouteImport
          })
const ArServicesIndexRoute = ArServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ArServicesRoute
          })
const ArServicesSlugRoute = ArServicesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ArServicesRoute
          })
const ArIndustriesIndexRoute = ArIndustriesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ArIndustriesRoute
          })
const ArIndustriesSlugRoute = ArIndustriesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ArIndustriesRoute
          })
const ServicesOilGasRegistrationOperatorRoute = ServicesOilGasRegistrationOperatorRouteImport.update({
            id: '/oil-gas-registration/$operator',path: '/oil-gas-registration/$operator',getParentRoute: () => ServicesRoute
          })
const ServicesIsoCertificationCityRoute = ServicesIsoCertificationCityRouteImport.update({
            id: '/iso-certification/$city',path: '/iso-certification/$city',getParentRoute: () => ServicesRoute
          })
const ArServicesOilGasRegistrationOperatorRoute = ArServicesOilGasRegistrationOperatorRouteImport.update({
            id: '/oil-gas-registration/$operator',path: '/oil-gas-registration/$operator',getParentRoute: () => ArServicesRoute
          })
const ArServicesIsoCertificationCityRoute = ArServicesIsoCertificationCityRouteImport.update({
            id: '/iso-certification/$city',path: '/iso-certification/$city',getParentRoute: () => ArServicesRoute
          })





const IndustriesRouteChildren = {
  IndustriesSlugRoute: IndustriesSlugRoute,IndustriesIndexRoute: IndustriesIndexRoute
}

const IndustriesRouteWithChildren = IndustriesRoute._addFileChildren(IndustriesRouteChildren)




const ServicesRouteChildren = {
  ServicesSlugRoute: ServicesSlugRoute,ServicesIndexRoute: ServicesIndexRoute,ServicesIsoCertificationCityRoute: ServicesIsoCertificationCityRoute,ServicesOilGasRegistrationOperatorRoute: ServicesOilGasRegistrationOperatorRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)




const ArIndustriesRouteChildren = {
  ArIndustriesSlugRoute: ArIndustriesSlugRoute,ArIndustriesIndexRoute: ArIndustriesIndexRoute
}

const ArIndustriesRouteWithChildren = ArIndustriesRoute._addFileChildren(ArIndustriesRouteChildren)




const ArServicesRouteChildren = {
  ArServicesSlugRoute: ArServicesSlugRoute,ArServicesIndexRoute: ArServicesIndexRoute,ArServicesIsoCertificationCityRoute: ArServicesIsoCertificationCityRoute,ArServicesOilGasRegistrationOperatorRoute: ArServicesOilGasRegistrationOperatorRoute
}

const ArServicesRouteWithChildren = ArServicesRoute._addFileChildren(ArServicesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,ContactRoute: ContactRoute,IndustriesRoute: IndustriesRouteWithChildren,PrivacyRoute: PrivacyRoute,ServicesRoute: ServicesRouteWithChildren,ArAboutRoute: ArAboutRoute,ArContactRoute: ArContactRoute,ArIndustriesRoute: ArIndustriesRouteWithChildren,ArPrivacyRoute: ArPrivacyRoute,ArServicesRoute: ArServicesRouteWithChildren,InsightsSlugRoute: InsightsSlugRoute,ArIndexRoute: ArIndexRoute,InsightsIndexRoute: InsightsIndexRoute,ArInsightsSlugRoute: ArInsightsSlugRoute,ArInsightsIndexRoute: ArInsightsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)